import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../ApiClient";


export const GetLostDoc = createAsyncThunk(
'CrmOpportunity/LostOppr',
    async ({dbName, OpprNo}, {dispatch, rejectWithValue}) => {        
        try {
            const response = await apiClient.get(`CrmOpportunity/GetLostOppr?DatabaseName=${dbName}&OpprNum=${OpprNo}`);            
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Error Fetching Data');
        }
    }
);



export const getDocNumbyOpprId = createAsyncThunk(
    'CrmOpportunity/DocNumbyOpprId',
        async ({databaseName, SlpCode,accessLevel,searchId}, {dispatch, rejectWithValue}) => {        
            try {
                const response = await apiClient.get(`CrmOpportunity/GetDocNumbyOpporId?DatabaseName=${databaseName}&SlpCode=${SlpCode}&AccessLevel=${accessLevel}&SearchOpprId=${searchId}`);            
                return response.data;
            } catch (error) {
                return rejectWithValue(error.response?.data || 'Error Fetching Data');
            }
        }
    );

  export const fetchOpprtunity = createAsyncThunk(
    'CrmOpportunity/fetchOpprtunity',
        async ({databaseName, SlpCode,accessLevel}, {dispatch, rejectWithValue}) => {        
            try {
                const response = await apiClient.get(`CrmOpportunity/GetCrmOpportunity?databaseName=${databaseName}&slpCode=${SlpCode}&accessLevel=${accessLevel}`);            
                return response.data;
            } catch (error) {
                return rejectWithValue(error.response?.data || 'Error Fetching Data');
            }
        }
    );
    export const getSQItems = createAsyncThunk(
        'CrmOpportunity/getSQItems',
            async ({databaseName,DocEntry}, {dispatch, rejectWithValue}) => {        
                try {
                    const response = await apiClient.get(`SQHistory/GetItemBySQ?DatabaseName=${databaseName}&DocEntry=${DocEntry}`);            
                    return response.data;
                } catch (error) {
                    return rejectWithValue(error.response?.data || 'Error Fetching Data');
                }
            }
        );

    